import { requireLib } from '@evm-ui/features/connect-wallet'
import { hydratedQueryFactory } from '@evm-ui/hooks/useHydratedQuery'
import type { ChainParams } from '@evm-ui/queries/query-types'
import { curveApiWithWalletValidationSuite } from '@evm-ui/queries/validation/curve-api-validation'
import type { QueryData } from '@ui/features/queries/util'

export const { useQuery: useBasePools, getQueryData: getBasePools } = hydratedQueryFactory({
  queryKey: ({ chainId }: ChainParams) => ({ name: 'base-pools', chainId }) as const,
  queryFn: async () => await requireLib('curveApi').getBasePools(),
  validationSuite: curveApiWithWalletValidationSuite,
  category: 'dex.poolParams',
})

export type BasePool = QueryData<typeof useBasePools>[number]
